import { EventBus, StorageAdapter } from '@pp/toolkit';

import { LocalStorage } from '../../storage/local/LocalStorage';

export class QuickGuideServiceBase extends EventBus<{
  'hint-visibility-changed': (visible: boolean) => void;
}> {
  private readonly VIEW_COUNT_LIMIT = 3;
  private readonly STORAGE_KEY_PREFIX = 'isQuickGuideShown';
  private initialised = false;
  private hintViewCount?: number;
  private storageKey?: string;

  private _isHintVisible = false;

  wasHintViewed = false;

  constructor(private storage: StorageAdapter) {
    super();
  }

  init(tableId: string): void {
    if (this.initialised) {
      return;
    }

    this.storageKey = `${this.STORAGE_KEY_PREFIX}-${tableId}`;

    this.hintViewCount = this.getHintViewCount();
    // Show button if it is still new for a user
    this.isHintVisible = this.hintViewCount < this.VIEW_COUNT_LIMIT;

    this.initialised = true;
  }

  getHintViewCount(): number {
    if (!this.storageKey) {
      console.error('QuickGuideService: tableId is not set');
      return 0;
    }
    const storedValue = this.storage.get(this.storageKey);
    return storedValue ? Number(storedValue) : 0;
  }

  setHintViewCount(value: number): void {
    if (!this.storageKey) {
      console.error('QuickGuideService: tableId is not set');
      return;
    }
    this.storage.set(this.storageKey, value.toString());
  }

  incrementHintViewCount(): void {
    if (this.hintViewCount === undefined) return;

    this.wasHintViewed = true;
    if (this.hintViewCount < this.VIEW_COUNT_LIMIT) {
      this.hintViewCount++;
      this.setHintViewCount(this.hintViewCount);
    }
  }

  get isHintVisible(): boolean {
    return this._isHintVisible;
  }

  private set isHintVisible(value: boolean) {
    // bother with event dispatching only if the value is really changed
    if (this._isHintVisible === value) return;
    this._isHintVisible = value;
    this.dispatchEvent('hint-visibility-changed', value);
  }

  hideHint(): void {
    this.isHintVisible = false;
  }

  killHint(): void {
    this.isHintVisible = false;
    this.setHintViewCount(3);
  }
}

export const QuickGuideService = new QuickGuideServiceBase(LocalStorage);
